import React, { createContext, type ReactNode, useContext } from 'react';

/**
 * Common interface for navigation adapters.
 */
export interface NavigationAdapter {
  currentPathname: string;
  navigate: {
    push: (path: string) => void;
  };
}

const NavigationContextProvider = createContext<NavigationAdapter | undefined>(
  undefined,
);

export interface NavigationProviderProps {
  children: ReactNode;
  adapter?: NavigationAdapter;
}

export const NavigationContext: React.FC<NavigationProviderProps> = ({
  children,
  adapter,
}) => {
  return (
    <NavigationContextProvider.Provider value={adapter}>
      {children}
    </NavigationContextProvider.Provider>
  );
};

export const useNavigationContext = (): NavigationAdapter => {
  const context = useContext(NavigationContextProvider);
  if (!context) {
    throw new Error(
      'useNavigationContext must be used within a NavigationContext',
    );
  }
  return context;
};
